/* tslint:disable */
/* eslint-disable */
/**
 * 不系舟 (lfr-unmoored) API
 * Family Hub 后端 API — Go 重写版。  Phase 2 codegen-ready 版本（SPEC-1..SPEC-9 完成）： - 全 path 带 operationId（驼峰命名） - 4xx/5xx 统一响应 ErrorResponse - 时间字段统一 date-time（RFC3339） - schema 标 required - request body 抽出命名 schema（XxxCreateRequest / XxxUpdateRequest） - v2.1.1 (BE-S5-002): content/text 字段加 description，明确语义边界 - v2.6.0 (BE-S11-001): 新增日程模块 /api/schedule/items（单日/区间查询、单条 CRUD、   批量整周替换、DDL 截止前一天提醒），数据按 X-User 隔离 - v2.7.0 (BE-TD-001): 既有漂移治理——补齐 68 个已上线 BE 路由（okr/memo/meetings/   tasks/shares/packing/travel/health/growth/agent/metrics/auth/todo 13 域），   listGrowth 返回类型修正为 map（对齐生产实现），spec ↔ BE 恢复 1:1 - v2.8.0: 日程新增 meal 类型；training / meal 通过 note 传递结构化计划详情 - v2.9.0: 日程新增 category 字段，删除「其他」兜底分区；所有事项必须归类为   timeline|work_plan|training_plan|meal_plan|life - v2.10.0: 新增自省语录 /api/okr/reflection（与 /api/okr/backdrop 同构，独立表） - v2.11.0 (PRD v3 待办+日程合并): /api/work/todo 升级为统一任务查询——新增   date/from/to 日历区间、status（含 overdue/held/pending 特殊口径）、type/tag 过滤，   新增 GET /api/work/todo/{id}；Todo schema 补 type/category/tag/url/startDate/   deadline/time/remindBefore/remindedAt/heldSince/createdAt/updatedAt，status 统一   6 值枚举（in_progress 下划线）；/api/schedule/items 转为过渡期别名（数据源=todos   单表，响应契约不变，标记 deprecated） 
 *
 * The version of the OpenAPI document: 2.13.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Anniversary } from '../models';
// @ts-ignore
import type { AnniversaryCreateRequest } from '../models';
// @ts-ignore
import type { AnniversaryUpdateRequest } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { ListAnniversaries200Response } from '../models';
/**
 * AnniversaryApi - axios parameter creator
 * @export
 */
export const AnniversaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create anniversary
         * @param {AnniversaryCreateRequest} anniversaryCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnniversary: async (anniversaryCreateRequest: AnniversaryCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anniversaryCreateRequest' is not null or undefined
            assertParamExists('createAnniversary', 'anniversaryCreateRequest', anniversaryCreateRequest)
            const localVarPath = `/api/life/anniversaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(anniversaryCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete anniversary
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnniversary: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAnniversary', 'id', id)
            const localVarPath = `/api/life/anniversaries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List anniversaries (sorted by date asc)
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAnniversaries: async (cursor?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/life/anniversaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update anniversary
         * @param {string} id 
         * @param {AnniversaryUpdateRequest} anniversaryUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnniversary: async (id: string, anniversaryUpdateRequest: AnniversaryUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAnniversary', 'id', id)
            // verify required parameter 'anniversaryUpdateRequest' is not null or undefined
            assertParamExists('updateAnniversary', 'anniversaryUpdateRequest', anniversaryUpdateRequest)
            const localVarPath = `/api/life/anniversaries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(anniversaryUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnniversaryApi - functional programming interface
 * @export
 */
export const AnniversaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnniversaryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create anniversary
         * @param {AnniversaryCreateRequest} anniversaryCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAnniversary(anniversaryCreateRequest: AnniversaryCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Anniversary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAnniversary(anniversaryCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnniversaryApi.createAnniversary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete anniversary
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAnniversary(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAnniversary(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnniversaryApi.deleteAnniversary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List anniversaries (sorted by date asc)
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAnniversaries(cursor?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAnniversaries200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAnniversaries(cursor, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnniversaryApi.listAnniversaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update anniversary
         * @param {string} id 
         * @param {AnniversaryUpdateRequest} anniversaryUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAnniversary(id: string, anniversaryUpdateRequest: AnniversaryUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Anniversary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAnniversary(id, anniversaryUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnniversaryApi.updateAnniversary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnniversaryApi - factory interface
 * @export
 */
export const AnniversaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnniversaryApiFp(configuration)
    return {
        /**
         * 
         * @summary Create anniversary
         * @param {AnniversaryApiCreateAnniversaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnniversary(requestParameters: AnniversaryApiCreateAnniversaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Anniversary> {
            return localVarFp.createAnniversary(requestParameters.anniversaryCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete anniversary
         * @param {AnniversaryApiDeleteAnniversaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnniversary(requestParameters: AnniversaryApiDeleteAnniversaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAnniversary(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List anniversaries (sorted by date asc)
         * @param {AnniversaryApiListAnniversariesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAnniversaries(requestParameters: AnniversaryApiListAnniversariesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListAnniversaries200Response> {
            return localVarFp.listAnniversaries(requestParameters.cursor, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update anniversary
         * @param {AnniversaryApiUpdateAnniversaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnniversary(requestParameters: AnniversaryApiUpdateAnniversaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Anniversary> {
            return localVarFp.updateAnniversary(requestParameters.id, requestParameters.anniversaryUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnniversaryApi - interface
 * @export
 * @interface AnniversaryApi
 */
export interface AnniversaryApiInterface {
    /**
     * 
     * @summary Create anniversary
     * @param {AnniversaryApiCreateAnniversaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnniversaryApiInterface
     */
    createAnniversary(requestParameters: AnniversaryApiCreateAnniversaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Anniversary>;

    /**
     * 
     * @summary Delete anniversary
     * @param {AnniversaryApiDeleteAnniversaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnniversaryApiInterface
     */
    deleteAnniversary(requestParameters: AnniversaryApiDeleteAnniversaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary List anniversaries (sorted by date asc)
     * @param {AnniversaryApiListAnniversariesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnniversaryApiInterface
     */
    listAnniversaries(requestParameters?: AnniversaryApiListAnniversariesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListAnniversaries200Response>;

    /**
     * 
     * @summary Update anniversary
     * @param {AnniversaryApiUpdateAnniversaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnniversaryApiInterface
     */
    updateAnniversary(requestParameters: AnniversaryApiUpdateAnniversaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Anniversary>;

}

/**
 * Request parameters for createAnniversary operation in AnniversaryApi.
 * @export
 * @interface AnniversaryApiCreateAnniversaryRequest
 */
export interface AnniversaryApiCreateAnniversaryRequest {
    /**
     * 
     * @type {AnniversaryCreateRequest}
     * @memberof AnniversaryApiCreateAnniversary
     */
    readonly anniversaryCreateRequest: AnniversaryCreateRequest
}

/**
 * Request parameters for deleteAnniversary operation in AnniversaryApi.
 * @export
 * @interface AnniversaryApiDeleteAnniversaryRequest
 */
export interface AnniversaryApiDeleteAnniversaryRequest {
    /**
     * 
     * @type {string}
     * @memberof AnniversaryApiDeleteAnniversary
     */
    readonly id: string
}

/**
 * Request parameters for listAnniversaries operation in AnniversaryApi.
 * @export
 * @interface AnniversaryApiListAnniversariesRequest
 */
export interface AnniversaryApiListAnniversariesRequest {
    /**
     * 
     * @type {string}
     * @memberof AnniversaryApiListAnniversaries
     */
    readonly cursor?: string

    /**
     * 
     * @type {number}
     * @memberof AnniversaryApiListAnniversaries
     */
    readonly limit?: number
}

/**
 * Request parameters for updateAnniversary operation in AnniversaryApi.
 * @export
 * @interface AnniversaryApiUpdateAnniversaryRequest
 */
export interface AnniversaryApiUpdateAnniversaryRequest {
    /**
     * 
     * @type {string}
     * @memberof AnniversaryApiUpdateAnniversary
     */
    readonly id: string

    /**
     * 
     * @type {AnniversaryUpdateRequest}
     * @memberof AnniversaryApiUpdateAnniversary
     */
    readonly anniversaryUpdateRequest: AnniversaryUpdateRequest
}

/**
 * AnniversaryApi - object-oriented interface
 * @export
 * @class AnniversaryApi
 * @extends {BaseAPI}
 */
export class AnniversaryApi extends BaseAPI implements AnniversaryApiInterface {
    /**
     * 
     * @summary Create anniversary
     * @param {AnniversaryApiCreateAnniversaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnniversaryApi
     */
    public createAnniversary(requestParameters: AnniversaryApiCreateAnniversaryRequest, options?: RawAxiosRequestConfig) {
        return AnniversaryApiFp(this.configuration).createAnniversary(requestParameters.anniversaryCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete anniversary
     * @param {AnniversaryApiDeleteAnniversaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnniversaryApi
     */
    public deleteAnniversary(requestParameters: AnniversaryApiDeleteAnniversaryRequest, options?: RawAxiosRequestConfig) {
        return AnniversaryApiFp(this.configuration).deleteAnniversary(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List anniversaries (sorted by date asc)
     * @param {AnniversaryApiListAnniversariesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnniversaryApi
     */
    public listAnniversaries(requestParameters: AnniversaryApiListAnniversariesRequest = {}, options?: RawAxiosRequestConfig) {
        return AnniversaryApiFp(this.configuration).listAnniversaries(requestParameters.cursor, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update anniversary
     * @param {AnniversaryApiUpdateAnniversaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnniversaryApi
     */
    public updateAnniversary(requestParameters: AnniversaryApiUpdateAnniversaryRequest, options?: RawAxiosRequestConfig) {
        return AnniversaryApiFp(this.configuration).updateAnniversary(requestParameters.id, requestParameters.anniversaryUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

